import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FastField } from 'formik';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import _isEmpty from 'lodash/isEmpty';

import combineStyles from '../../../utils/combineStyles';
import LayoutStyles from '../../../styles/layout';
import SpacingStyles from '../../../styles/helpers/spacing';
import TypographyStyles from '../../../styles/typography';
import TextFieldInput from '../../Global/Inputs/TextField';
import FormItemContainer from '../../Global/Containers/FormItemContainer';

export class BOLInstructions extends Component {
  static propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    defaultBolInstructions: PropTypes.string
  };

  render() {
    const {
      t,
      classes,
      values,
      handleChange,
      defaultBolInstructions
    } = this.props;

    return (
      <FormItemContainer title={t('BOL Instructions')}>
        <FastField
          name="bolInstructions"
          onChange={handleChange}
          render={({ field, form }) => {
            return (
              <TextFieldInput
                value={
                  _isEmpty(values.bolInstructions)
                    ? defaultBolInstructions
                    : values.bolInstructions
                }
                classes={{ root: classes.noMarginBottom }}
                field={field}
                form={form}
                label={t('Notes')}
                multiline={true}
                withError={'true'}
              />
            );
          }}
        />
      </FormItemContainer>
    );
  }
}

const BOLInstructionsWithTranslations = withNamespaces()(BOLInstructions);
export default withStyles(
  combineStyles(TypographyStyles, LayoutStyles, SpacingStyles)
)(BOLInstructionsWithTranslations);
